export const documentTemplates = {
    license: {
        key: 'public_file_link_license',
        text: 'License'
    },
    certificate: {
        key: 'public_file_link_certificate',
        text: 'Certificate'
    },
    site_rules: {
        key: 'public_file_link_site_rules',
        text: 'Terms and Conditions'
    },
    privacy_policy: {
        key: 'public_file_link_privacy_policy',
        text: 'Privacy Policy'
    },
    link_excerpt: {
        key: 'public_file_link_excerpt',
        text: 'Extract from provision'
    },
    rules_for_visiting: {
        key: 'public_file_link_rules_for_visiting',
        text: 'Terms of use'
    },
    public_offer: {
        key: 'public_file_link_public_offer',
        text: 'Terms of Service'
    }
};

export const gamersTemplates = {
    responsible_game: {
        key: 'public_file_link_responsible_game',
        text: ' Responsible gambling'
    }
};


// WEBPACK FOOTER //
// ./_layout/js/constants_en.js